<ng-container *transloco="let t">
  <ld-base-modal [title]="t('modalsUnconsentTitle')" [closeOnBackdropClick]="!isLoading()" (closeModal)="onCancel()">
    <div modal-content>
      <div class="p-4 bg-amber-50 border border-amber-200 rounded-xl mb-4">
        <div class="flex items-start gap-3">
          <mat-icon class="text-amber-600 shrink-0 mt-0.5">warning</mat-icon>
          <p class="font-dm text-sm text-amber-800">
            {{ warningText() || defaultWarning() }}
          </p>
        </div>
      </div>

      @if (showConfirmation()) {
        <div class="p-4 bg-red-50 border border-red-200 rounded-xl">
          <p class="font-dm text-sm text-red-800 font-medium mb-2">{{ t('modalsUnconsentConfirmQuestion') }}</p>
          <p class="font-dm text-xs text-red-700">{{ t('modalsUnconsentCannotUndo') }}</p>
        </div>
      }
    </div>
    <div modal-footer>
      <button
        id="unconsent-cancel-btn"
        type="button"
        class="btn-outline-ld-purple w-auto!"
        [disabled]="isLoading()"
        (click)="onCancel()"
      >
        {{ t('modalsUnconsentKeepButton') }}
      </button>
      <button
        id="unconsent-confirm-btn"
        type="button"
        [class]="
          showConfirmation()
            ? 'btn-solid-red w-auto! whitespace-nowrap'
            : 'btn-primary-ld-purple w-auto! whitespace-nowrap'
        "
        [disabled]="isLoading()"
        (click)="onWithdraw()"
      >
        @if (isLoading()) {
          <mat-spinner diameter="16" class="w-4! h-4! [&_circle]:stroke-white!"></mat-spinner>
        }
        {{ showConfirmation() ? t('modalsUnconsentConfirmWithdrawButton') : t('modalsUnconsentWithdrawButton') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
